export const Theme = {
	global: {
		body: document.querySelector("body")
	},
	init: function() {
		this.setTheme();
		this.ready();
		if (document.querySelector(".error404")) {
			document.documentElement.setAttribute("data-theme", "dark");
		}
	},
	setTheme: function() {
		let url = window.location.href;
		let exp = url.split(/^(([^:\/?#]+):)?(\/\/([^\/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?/);
		switch (exp[5]) {
			case "/":
			case "/contact/":
			case "/jobs/":
			case "/csa/":
			case "/inscription-newsletter/":
				document.documentElement.setAttribute("data-theme", "dark");
				break;
			default:
		}
	},
	ready() {
		document.documentElement.setAttribute("data-ready", "true");
	}
};



// WEBPACK FOOTER //
// ./src/scripts/components/Theme.js